import { Fullscreen } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { type ReactNode } from "react";

const tEnterFullscreen = "Enter full screen";

export interface VisitorManagementKioskTemplateProps {
  children: ReactNode;
  isFullscreen: boolean;
  onRequestFullscreen: () => void;
}

export function VisitorManagementKioskTemplate({
  children,
  isFullscreen,
  onRequestFullscreen,
}: VisitorManagementKioskTemplateProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        minHeight: 0,
        pb: isFullscreen ? 0 : 11,
        position: "relative",
        width: "100%",
      }}
    >
      {children}
      {!isFullscreen ? (
        <Box
          sx={{
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            left: 0,
            pb: 2,
            pointerEvents: "none",
            position: "fixed",
            pt: 1,
            px: 2,
            right: 0,
            zIndex: (theme) => theme.zIndex.modal - 1,
          }}
        >
          <Button
            fullWidth
            color="primary"
            size="large"
            startIcon={<Fullscreen />}
            sx={{
              boxShadow: 4,
              maxWidth: 480,
              pointerEvents: "auto",
              py: 2,
              typography: "h6",
            }}
            variant="contained"
            onClick={onRequestFullscreen}
          >
            {tEnterFullscreen}
          </Button>
        </Box>
      ) : null}
    </Box>
  );
}
